fragment InboundFacebookRulesFragment on InboundFacebookRules {
    assignment {
        strategy
        assignedUser {
            id
            name
        }
    }
    leadCreation {
        enabled
        stageset {
            id
            name
        }
        tags {
            id
            name
        }
    }
}
